import React from "react";

export default function SettingsSubHeader({children}) {
    return <h5 style={{fontWeight: '400'}} className='ms-2 settings-sub-header'>{children}</h5>;
}